import React, { useState } from 'react';
import './CartCheckOut.css';
import { useSelector } from 'react-redux';
import { selectCartItems } from '../../Utilities/cartSelectors';
import axiosInstance from '../../Config/axiosConfig';
import { Button, Input, message, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import AlreadyPurchasedModal from '../AlreadyPurchasedModal/AlreadyPurchasedModal';
import { 
  LockFilled,
  ArrowRightOutlined,
  PhoneOutlined,
  ExclamationCircleFilled
} from '@ant-design/icons';

const { confirm } = Modal;

const CartCheckOut = ({ classId, mobileCartData }) => {
  console.log('mobile data',mobileCartData)
  // Determine which cart to use: mobileCartData if available, otherwise redux cart
  const reduxCart = useSelector(selectCartItems) || [];
  const cart = mobileCartData?.items?.length > 0 ? mobileCartData.items : reduxCart;
  const total = mobileCartData?.totalAmount ?? cart.reduce(
    (acc, item) => acc + (item.price || item.cost || 0) * (item.quantity || 1),
    0
  );

  const [phone, setPhone] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [showAlreadyPurchasedModal, setShowAlreadyPurchasedModal] = useState(false);
  const navigate = useNavigate();

  const showPaymentConfirmation = (decodedUrl, invoiceIdStatus) => {
    confirm({
      title: 'You are being redirected to the payment gateway',
      icon: <ExclamationCircleFilled />,
      content:
        'A new tab will open for secure payment processing. Please make sure to complete the payment process and return to this window afterward.',
      okText: 'Proceed to Payment',
      cancelText: 'Cancel',
      onOk() {
        openPaymentTab(decodedUrl, invoiceIdStatus);
      },
      onCancel() {
        setIsProcessing(false);
      },
    });
  };

  const openPaymentTab = (url, invoiceIdStatus) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    navigate('/await-payment=status', {
      state: { amount: total, invoiceUid: invoiceIdStatus }
    });
  };

  const handlePayment = async () => {
    if (!phone) {
      message.error('Please enter your phone number');
      return;
    }

    setIsProcessing(true);

    const accessToken = localStorage.getItem("accessToken");
    // alert('check access Token', accessToken)
    const storedDeviceId = localStorage.getItem("deviceId");
    const storedUserIp = localStorage.getItem("userIp");

    try {
      const paymentData = {
        phone_no: phone,
        total_amount: total,
        total_classes: cart.length,
        items: cart.map(item => ({
          class_uid: item.class_uid || item.id || classId,
          price: item.price || item.cost || 0
        }))
      };
      console.log('check pay', JSON.stringify(paymentData))
      const response = await axiosInstance.post('Invoice/create-invoice', paymentData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          UserDevice: storedDeviceId,
          UserIPAddress: storedUserIp,
        }
      });

      const code = response.data?.code;
      const data = response.data?.data;

      if (code === 200 && data) {
        const decodedUrl = atob(data.payment_gateway_url.trim().replace(/\s/g, ''));
        if (decodedUrl.startsWith('http://') || decodedUrl.startsWith('https://')) {
          showPaymentConfirmation(decodedUrl, data.invoice_id);
        } else {
          message.error('Invalid payment gateway URL');
          setIsProcessing(false);
        }
      } else if (code === 401) {
        message.warning('Please sign in to make payments');
        navigate('/signIn');
        setIsProcessing(false);
      } else if (code === 412) {
        setShowAlreadyPurchasedModal(true);
        setIsProcessing(false);
      } else if (code === 417) {
        message.warning('Payment failed due to payment gateway error');
        setIsProcessing(false);
      } else {
        message.error(`Payment failed: ${response.data?.message || 'Unknown error'}`);
        setIsProcessing(false);
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      message.error(errorMessage || 'An unexpected error occurred');
      setIsProcessing(false);
    }
  };

  return (
    <div className="checkout-container">
      <div className="checkout-header">
        <h1 className="checkout-title">Secure Checkout</h1>
        <div className="progress-steps">
          <div className="step active">Invoice</div>
          <div className="step-connector active"></div>
          <div className="step active">Payment</div>
          <div className="step-connector"></div>
          <div className="step">Complete</div>
        </div>
      </div>

      <div className="payment-method-selector">
        <div className="method-card active">
          <div className="method-icon mobile">
            <PhoneOutlined />
          </div>
          <div className="method-details">
            <h4>Mobile Money</h4>
          </div>
        </div>
      </div>

      <div className="payment-details-section">
        <div className="input-field">
          <label>Mobile Number</label>
          <Input
            placeholder="XXX XXX XXX"
            prefix="+255"
            size="large"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div className="payment-hint">
          <LockFilled />
          <span>100% secure mobile payment</span>
        </div>
      </div>

      <div className="order-summary-section">
        <h4 className="summary-title">Order Summary</h4>
        <div className="summary-items">
          <div className="summary-item">
            <span className="cart-length-title">Number of classes</span>
            <span className="cart-length-title">{cart.length}</span>
          </div>
          <div className="summary-item total">
            <span>Total Amount</span>
            <span>Tsh {total.toLocaleString()}</span>
          </div>
        </div>
      </div>

      <Button
        type="primary"
        size="large"
        block
        className="pay-button"
        onClick={handlePayment}
        loading={isProcessing}
      >
        {isProcessing ? 'Processing...' : (
          <>
            Complete Payment
            <ArrowRightOutlined />
          </>
        )}
      </Button>

      <div className="security-badges">
        <div className="badge">256-bit SSL</div>
        <div className="badge">PCI DSS</div>
        <div className="badge">3D Secure</div>
      </div>

      <AlreadyPurchasedModal
        visible={showAlreadyPurchasedModal}
        onClose={() => {
          setShowAlreadyPurchasedModal(false);
          setIsProcessing(false);
        }}
      />
    </div>
  );
};

export default CartCheckOut;
